import { Fragment, useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import MenuContext from '../../store/MenuContext';
import CategoryMenu from '../Categories/CategoryMenu';
import CategoryModal from '../Categories/CategoryModal';
import AvailableTests from './AvailableTests';
import TestHeader from '../TestsHeader/TestsHeader';

import { getLabConfig, getCategories, getSystemMsg } from '../../utils/api';
const AvailablewithCat = () => {
		// Modal UI states
	const [menuIsOpen, setMenuIsOpen] = useState(false);
	const openMenuHandler = () => setMenuIsOpen(true);
	const closeMenuHandler = () => setMenuIsOpen(false);
	
    const urlParams = useParams();
	const menuTheme = useContext(MenuContext);
	const [superCat, setSuperCat] = useState([]);
	const [banner,setBanner] = useState('');
	
	// Fetch Super Categories
	useEffect(() => {
		async function fetchSuperCategories() {
			const data = await getCategories('1');
			setSuperCat(data);
		}
		fetchSuperCategories();
	}, []);

	useEffect(() => {
		async function fetchBanner() {
			const data = await getSystemMsg("Banner");
			setBanner(data);
		}
		fetchBanner();
	}, []);
	// SEO setup
	const [HomeTitle, setHomeTitle] = useState('');
	const [PortalTitle, setPortalTitle] = useState([]);
	useEffect(() => {
        async function fetchPortalTitle() {
            const portalTitle = await getLabConfig('DTCLABEL');
            setPortalTitle(portalTitle);
        }
        fetchPortalTitle();
    }, []);
	useEffect(() => {
		async function setupSEO() {
			const homeTitle = await getLabConfig("DTCHTMLTITLE");
			setHomeTitle(homeTitle);
	  }
	  setupSEO();
	}, []);
	useEffect(() => {
		document.title = HomeTitle;
		return () => {
			document.title = PortalTitle;
		};
	}, [HomeTitle]);

	return (
		<>
			{/* Layout rendering */}
			{menuTheme === "TOP" && (
				<>
					<TestHeader banner={banner} onOpenMenu={openMenuHandler} />
					{menuIsOpen && <CategoryModal onClose={closeMenuHandler} />}
					{superCat && (
						<main className='mainLayout'>
							<CategoryMenu />
							<AvailableTests page={urlParams.page} />
						</main>
					)}
				</>
			)}

			{menuTheme === "HAMBURGER" && (
				<Fragment>
					<AvailableTests superCat={superCat} page={urlParams.page} />
				</Fragment>
			)}
		</>
			
	)};

export default AvailablewithCat;